<template>
  <div>
    <div>
      <div class="searchArea">
        <a-select v-model:value="clubId" placeholder="门店" style="width: 275px;">
          <a-select-option v-for="item in clubList" :value="item.id" :key="item.id">{{ item.name }}</a-select-option>
        </a-select>
        <a-button type="primary" shape="circle" @click="search('')">
          <template #icon>
            <SearchOutlined />
          </template>
        </a-button>
        <a-button style="margin-left: 10px" type="primary" @click="getLastMonday()">
          <template #icon>
            <PlusOutlined />
          </template>
          上一周
        </a-button>
        <a-button style="margin-left: 10px" type="primary" @click="getNextMonday()">
          <template #icon>
            <PlusOutlined />
          </template>
          下一周
        </a-button>
      </div>
      <a-table class="ant-table-striped no-border" :columns="columns" :data-source="data" :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)" :row-selection="auth.canBatchManage ? { selectedRowKeys: selectedRowKeys, onChange: onSelectChange } : null" bordered rowKey="id" :scroll="{ y: 500 }" :pagination="false" @change="search">
        <template #operation="{ record }">
          <div class="flex_sa">
            <div class="editable-row-operations flex_sa">
              <span>
                <a @click="edit(record)">编辑</a>
              </span>
            </div>
            <div class="editable-row-operations flex_sa">
              <span>
                <a @click="edit2(record)">
                  <span v-if="record.appSetting?.scheduleAvailable">停诊</span>
                  <span v-else>出诊</span>
                </a>
              </span>
            </div>
          </div>

        </template>
        <template #date="{ text, record, column }">
          <span class="date-text">{{ text || '--' }}</span>
        </template>

        <template #week="{ text, record, column }">
          <span class="week-text">{{ text || '--' }}</span>
        </template>

        <template v-for="col in ['am', 'pm']" #[col]="{ text, record, column }">
          <div :class="text?'true':'false'" @click="changeStatus(record, column.dataIndex)">
            <span v-if="text">✓</span>
            <span v-else>X</span>
          </div>
        </template>
      </a-table>
      <div class="buttonBox">
        <a-button v-if="auth.canModifySchedule" @click="saveChangedStatus" type="primary">保存</a-button>
        <a-button v-if="auth.canBatchManage" @click="copyScheduleWeek" type="primary">复制周排班</a-button>
      </div>
    </div>

    <copySchedule v-model="visible" :record="selectedRowKeys" :clubId="currentClubId" :date="date" />

  </div>
</template>

<style scoped>
.online {
  background: #40a9ff;
  border-color: #40a9ff;
}

.offline {
  background: #979596;
  border-color: #979596;
}

:deep(.ant-table-tbody > tr > td, .ant-table-thead > tr > th) {
  padding: 10px 8px;
}

.table_btn {
  width: 70px;
  display: inline-block;
  text-align: center;
}

.clickable {
  /* background-color: #000; */
  width: 100%;
  height: 100%;
}

.true {
  background: #52c41a;
  color: #fff;
}

.true,
.false {
  /* color: ; */
  cursor: pointer;
}
.table-striped {
  background-color: #fafafa;
}

.buttonBox {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.buttonBox button {
  margin: 0 10px;
}
</style>

<script>
import {
  SearchOutlined,
  PlusOutlined,
  DownloadOutlined,
  CheckCircleFilled,
  WarningFilled,
  FormOutlined
} from "@ant-design/icons-vue";
import { reactive } from "vue";
import { cloneDeep } from "lodash-es";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import { SearchSchedule, EditSchedule } from "/src/api/appointment.js";
import { ClubList } from "/src/api/businessManage/summary.js";
import getAutoPrescription from '/src/components/autoPrescription/getAutoPrescription.vue';
import editDoctor from '/src/components/doctorManage/editDoctor.vue';
import settingDoctor from '/src/components/doctorManage/settingDoctor.vue';
import copySchedule from '/src/components/schedule/copySchedule.vue';
import { GetPageOperationList } from "/src/api/sys.js";

export default {
  components: {
    SearchOutlined,
    PlusOutlined,
    DownloadOutlined,
    locale,
    CheckCircleFilled,
    WarningFilled,
    getAutoPrescription,
    FormOutlined,
    editDoctor,
    settingDoctor,
    copySchedule
  },
  name: "预约排班管理",
  data() {
    return {
      modalBtn: "",
      modalIndex: "0",
      active: undefined,
      visible: false,
      id: undefined,
      date: undefined,
      selectedRow: {},
      auth: {
        canModifySchedule: false, // 对应：操作-排班管理-修改排班
        canBatchManage: false     // 对应：操作-排班管理-批量管理
      },
      total: 0,
      current: 1,
      startDate: undefined,
      endDate: undefined,
      // pageSize: 10,
      inputs: {
        name: undefined,
        gender: undefined,
        isStandard: undefined,
      },
      clubList: [],
      clubId: undefined,
      currentClubId: undefined,
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
      columns: [],
      data: [],
      selectedRowKeys: [],
      selectedRows: [],
      changeStatusList: [],
      editableData: reactive({}),
      record: {},
      selectClub: undefined,

      // doExcel: doExcel
    };
  },
  created() { },
  mounted() {
    this.init();
  },
  activated() {
  },
  methods: {
    async init() {
      this.generateColumns(this.getThisMonday());
      this.getPageAuth();
      await this.getClubList();
    },
    async getPageAuth() {
      try {
        const params = {
          name: "页面-排班管理",
        };

        let res = await GetPageOperationList(params);

        if (res.errCode === 0 && Array.isArray(res.data)) {
          const operations = res.data;
          this.auth.canModifySchedule = operations.includes("操作-修改排班") || operations.includes("操作-排班管理-修改排班");
          this.auth.canBatchManage = operations.includes("操作-批量管理") || operations.includes("操作-排班管理-批量管理");
        }
      } catch (error) {
        console.error("获取排班页面权限失败:", error);
      }
    },
    getThisMonday() {
      const today = new Date();
      const day = today.getDay(); // 周日是0，周一是1，周六是6
      const diff = today.getDate() - day + (day === 0 ? -6 : 1); // 调整周日的特殊情况
      return new Date(today.setDate(diff));
    },
    getLastMonday() {
      const date = this.date;
      const lastMonday = new Date(date);
      lastMonday.setDate(date.getDate() - 7);
      this.generateColumns(lastMonday)
      this.search("")
    },
    getNextMonday() {
      const date = this.date;
      const nextMonday = new Date(date);
      nextMonday.setDate(date.getDate() + 7);
      this.generateColumns(nextMonday)
      this.search("")
    },
    // 【修改点】: 合并了原代码中定义两次的 getClubList 方法，修正了 clubId 赋值逻辑
    async getClubList() {
      try {
        let res = await ClubList();
        console.log("门店列表:", res.data);

        if (res.errCode === 0 && res.data) {
          this.clubList = res.data;

          if (this.clubList.length === 1) {
            this.clubId = this.clubList[0].id; // 这里修改为取 id
            this.search("");
          }
        }
      } catch (error) {
        console.error("获取门店列表异常:", error);
      }
    },
    closeModal(value) {
      this[value] = false;
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      console.log('selectedRowKeys changed: ', this.selectedRowKeys);
      console.log('selectedRows changed: ', this.selectedRows);

      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    resetForm() {
      this.inputs = {
        name: undefined,
        gender: undefined,
        isStandard: undefined,
      }
    },
    tabsName(tabName) {
      this.$store.commit("changePage", { name: tabName.name, query: tabName.query });
    },
    transformData(apiData) {
      const weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

      return apiData.map((doctor) => {
        const baseRecord = {
          key: doctor.doctorId.toString(),
          id: doctor.doctorId.toString(),
          name: doctor.doctorName,
        };

        // 为每个日期创建对应的字段
        doctor.dateList.forEach(dateInfo => {
          const date = new Date(dateInfo.date);

          // const weekday = weekdays[date.getDay()];
          // 日期字段
          // baseRecord[`date_${dateInfo.date}`] = dateInfo.date;
          // 星期字段
          // baseRecord[`week_${dateInfo.date}`] = weekday;
          // 上午字段 - 根据 available 状态显示
          baseRecord[`am_${dateInfo.date}`] = dateInfo.am ? dateInfo.am.available : false;
          baseRecord[`am_${dateInfo.date}_id`] = dateInfo.am ? dateInfo.am.id : undefined;
          // 下午字段 - 根据 available 状态显示
          baseRecord[`pm_${dateInfo.date}`] = dateInfo.pm ? dateInfo.pm.available : false;
          baseRecord[`pm_${dateInfo.date}_id`] = dateInfo.pm ? dateInfo.pm.id : undefined;
        });

        return baseRecord;
      });
    },
    async search(pagination) {
      let _this = this;
      this.changeStatusList = []
      let params = {
        clubId: this.clubId,
        dateFrom: this.startDate,
        dateTo: this.endDate,
      };

      if (pagination == "") {
        params.current = 1
      } else {
        params.current = pagination.current
        this.current = pagination.current;
      }

      let res = await SearchSchedule(params)
      console.log('API返回数据:', res);

      if (res.errCode == 0) {
        this.currentClubId = this.clubId
        if (pagination == "") {
          this.current = 1;
          this.selectClubId = this.inputs.clubId
        }

        // 转换数据格式
        if (res.data && Array.isArray(res.data)) {
          this.data = this.transformData(res.data);
          console.log('转换后的表格数据:', this.data);
        } else {
          this.data = [];
          console.warn('API返回数据格式异常');
        }

      } else {
        this.$message.error("查询失败", function () { });
        this.data = [];
      }
    },
    // 获取一周日期数据
    getWeekDates(day) {
      const weekDates = [];
      const startDate = new Date(day);
      const weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

      for (let i = 0; i < 7; i++) {
        const date = new Date(startDate);
        date.setDate(startDate.getDate() + i);

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const dayNum = String(date.getDate()).padStart(2, '0');
        const weekday = weekdays[date.getDay()];

        weekDates.push({
          dateStr: `${year}-${month}-${dayNum}`,
          weekday: weekday,
          fullDate: new Date(date)
        });
      }
      this.startDate = weekDates[0].dateStr
      this.endDate = weekDates[6].dateStr
      return weekDates;
    },
    // 动态生成列配置
    generateColumns(day) {
      this.date = day
      const weekDates = this.getWeekDates(day);
      const dateColumns = weekDates.map(dateInfo => {
        return {
          title: dateInfo.dateStr,
          key: `date_${dateInfo.dateStr}`,
          dataIndex: `date_${dateInfo.dateStr}`,
          width: '10%',
          slots: {
            customRender: 'date'
          },
          children: [
            {
              title: dateInfo.weekday,
              key: `week_${dateInfo.dateStr}`,
              dataIndex: `week_${dateInfo.dateStr}`,
              width: '100%',
              slots: {
                customRender: 'week'
              },
              children: [
                {
                  title: '上午',
                  key: `am_${dateInfo.dateStr}`,
                  dataIndex: `am_${dateInfo.dateStr}`,
                  width: '50%',
                  slots: {
                    customRender: 'am'
                  }
                },
                {
                  title: '下午',
                  key: `pm_${dateInfo.dateStr}`,
                  dataIndex: `pm_${dateInfo.dateStr}`,
                  width: '50%',
                  slots: {
                    customRender: 'pm'
                  }
                }
              ]
            }
          ]
        };
      });

      const columns = [
        {
          title: "姓名",
          key: "name",
          dataIndex: "name",
          width: "30%",
          slots: {
            customRender: "name"
          }
        },
        ...dateColumns,
      ];

      this.columns = columns;
    },
    async changeStatus(record, key) {

      if (!this.auth.canModifySchedule) return;

      record[key] = !record[key];

      const id = record[`${key}_id`];
      const date = key.split('_')[1];
      const section = key.startsWith('am_') ? '上午' : '下午';

      const obj = {
        available: record[key],
        doctorId: record.id,
        clubId: this.currentClubId,
        date,
        section
      };

      if (id) {
        obj.id = id;
      }

      // 查找是否已有相同 id 的记录（仅当 id 存在时）
      if (id) {
        const existingIndex = this.changeStatusList.findIndex(item => item.id === id);
        if (existingIndex > -1) {
          this.changeStatusList[existingIndex] = { ...obj };
          // console.log("已更新（通过 id）:", obj);
          return;
        }
      }

      // 如果没有 id 或未找到 id 匹配，则通过 doctorId + date + section 去重
      const duplicateIndex = this.changeStatusList.findIndex(item =>
        item.doctorId === obj.doctorId &&
        item.date === obj.date &&
        item.section === obj.section
      );

      if (duplicateIndex > -1) {
        this.changeStatusList[duplicateIndex] = { ...obj };
        // console.log("已更新（通过 doctor+date+section）:", obj);
      } else {
        this.changeStatusList.push({ ...obj });
        // console.log("已新增:", obj);
      }

      // console.log("changeStatusList", this.changeStatusList);
    },
    async saveChangedStatus() {
      console.log(this.changeStatusList);

      let res = await EditSchedule(this.changeStatusList)
      if (res.errCode == 0) {
        this.$message.success("修改成功", function () { });
        this.changeStatusList = []
        this.search("")
      } else {
        this.$message.error("修改失败", function () { });
      }
    },
    copyScheduleWeek() {
      if (this.selectedRows.length == 0) {
        this.$message.error("请至少选择一名医生");
        return
      }
      this.visible = true
      console.log(this.selectedRows);

    }

  }
};
</script>